module.exports = __webpack_public_path__ + "static/media/video_thumb2.34b8999c.png";